var _circle, _g;

function _extends() { _extends = Object.assign || function (target) { for (var i = 1; i < arguments.length; i++) { var source = arguments[i]; for (var key in source) { if (Object.prototype.hasOwnProperty.call(source, key)) { target[key] = source[key]; } } } return target; }; return _extends.apply(this, arguments); }

import * as React from "react";

function SvgIconCircleMealKit(props) {
  return /*#__PURE__*/React.createElement("svg", _extends({
    fill: "none",
    viewBox: "0 0 46 46",
    xmlns: "http://www.w3.org/2000/svg"
  }, props), _circle || (_circle = /*#__PURE__*/React.createElement("circle", {
    cx: 23,
    cy: 23,
    fill: "#e3fb94",
    r: 23
  })), _g || (_g = /*#__PURE__*/React.createElement("g", {
    stroke: "#000",
    strokeWidth: 2
  }, /*#__PURE__*/React.createElement("path", {
    d: "M17.559 36.44h10.923",
    strokeLinecap: "round"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M12.282 21.965h21.5c1.124 0 1.803.845 1.649 1.696-.344 1.904-1.145 4.393-2.974 6.396-1.798 1.969-4.676 3.563-9.385 3.563-4.701 0-7.592-1.59-9.408-3.556-1.846-2-2.669-4.487-3.03-6.392-.161-.855.517-1.707 1.648-1.707z"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M25.752 18.008l1.393 2.73 1.338-2.73",
    strokeLinecap: "round",
    strokeLinejoin: "round"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M21.11 22.103a4.336 4.336 0 01-.82-2.545c0-2.22 1.371-3.568 3.474-3.745.78-.91 1.552-1.903 3.353-1.903 1.8 0 2.301.992 3.08 1.903 2.104.177 3.747 1.526 3.747 3.746 0 .915-.292 1.818-.82 2.543M13.451 22.105a4.682 4.682 0 01-.003-6.584c.148-.147.395-.287.554-.231.207 0 .405.082.551.226l5.51 5.49a.774.774 0 010 1.098"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M14.827 16.168c.34-2.844 2.391-4.988 4.771-4.988.382 0 .691.376.691.84v10.084"
  }))));
}

export default __webpack_public_path__ + "media/images/styleguide/icons/icon-circle--meal-kit-803671b3483009cf8f53689377933280.svg";
export { SvgIconCircleMealKit as Component };